import { combineReducers, compose, createStore, applyMiddleware } from "redux";
import createSagaMiddleware from "@redux-saga/core";
import { logger, crashReporter } from "../../../store";
import rootSaga from "../sagas";

import {
    subsidiariesList,
    subsidiariesLoading
} from "../reducers/subsidiaries.reducer";
import {
    presetsList,
    presetsLoading,
    editingPreset,
    submitPresetLoading,
    submittingPresetState,
    presetLoading,
    initialPreset,
    initialPresetPrizes,
    initialGameSpecificSettings
} from "../reducers/presets.reducer";
import {
    denominations,
    denominationsLoading
} from "../reducers/denominations.reducer";
import {
    games,
    gamesLoading,
    gameBundles,
    gameBundlesLoading
} from "../reducers/game.reducer";

const presetsReducer = combineReducers({
    subsidiariesList,
    subsidiariesLoading,
    presetsList,
    presetsLoading,
    editingPreset,
    submitPresetLoading,
    submittingPresetState,
    presetLoading,
    initialPreset,
    initialPresetPrizes,
    initialGameSpecificSettings,
    denominations,
    denominationsLoading,
    games,
    gamesLoading,
    gameBundles,
    gameBundlesLoading,
});


const composeEnhancers = window["__REDUX_DEVTOOLS_EXTENSION_COMPOSE__"]
    ? window["__REDUX_DEVTOOLS_EXTENSION_COMPOSE__"]({
          name: "Presets Store"
      })
    : compose;

const sagaMiddleware = createSagaMiddleware();

export const presetsStore = createStore(
    presetsReducer,
    {},
    composeEnhancers(applyMiddleware(sagaMiddleware, logger, crashReporter))
);

export const presetsStoreSelectors = {
    subsidiariesList: (state = presetsStore.getState()) =>
        state.subsidiariesList,
    subsidiariesLoading: (state = presetsStore.getState()) =>
        state.subsidiariesLoading,
    presetsList: (state = presetsStore.getState()) => state.presetsList,
    presetsLoading: (state = presetsStore.getState()) => state.presetsLoading,
    editingPreset: (state = presetsStore.getState()) => state.editingPreset,
    submitPresetLoading: (state = presetsStore.getState()) =>
        state.submitPresetLoading,
    submittingPresetState: (state = presetsStore.getState()) =>
        state.submittingPresetState,
    presetLoading: (state = presetsStore.getState()) => state.presetLoading,
    initialPreset: (state = presetsStore.getState()) => state.initialPreset,
    initialPresetPrizes: (state = presetsStore.getState()) =>
        state.initialPresetPrizes,
    initialGameSpecificSettings: (state = presetsStore.getState()) =>
        state.initialGameSpecificSettings,
    denominations: (state = presetsStore.getState()) => state.denominations,
    denominationsLoading: (state = presetsStore.getState()) =>
        state.denominationsLoading,
    games: (state = presetsStore.getState()) => state.games,
    gamesLoading: (state = presetsStore.getState()) => state.gamesLoading,
    gameBundles: (state = presetsStore.getState()) => state.gameBundles,
    gameBundlesLoading: (state = presetsStore.getState()) => state.gameBundlesLoading,
};

sagaMiddleware.run(rootSaga);
